import { PaymentWorkflowType } from '../components/container/forms/types/api/graph.types';

export const workflowTypeToFolder: Record<PaymentWorkflowType, string> = {
  [PaymentWorkflowType.Undefined]: 'Undefined',
  // [PaymentWorkflowType.UKPaymentApproval]: 'UKPaymentApproval',
  [PaymentWorkflowType.DubaiPaymentApproval]: 'DubaiPaymentApproval', // Need to update this when locale comes around
  [PaymentWorkflowType.DubaiTransferRequisition]: 'DubaiTransferRequisition',
  [PaymentWorkflowType.DubaiPaymentFromOfficeAcc]: 'DubaiPaymentFromOfficeAcc',
  [PaymentWorkflowType.OvertimeApproval]: 'OvertimeApproval',
  [PaymentWorkflowType.GiftHospitalityDonationUk]: 'GiftHospitalityDonationUk',
  [PaymentWorkflowType.GiftHospitalityDonationDubai]: 'GiftHospitalityDonationDubai',
  [PaymentWorkflowType.GiftHospitalityDonationDublin]: 'GiftHospitalityDonationDublin',
// PLOP_INJECT_WORKFLOW_TYPE_FOLDER
};
